import React, {useEffect, useRef, useState} from 'react';
import {Row, Col} from 'reactstrap';
import {Field} from 'react-final-form';
import Select from "react-select";

const FormCsvField = ({field, fieldsToMap, savedSettings, typeChanged, fieldMapping, formatOptionLabel, form, onFieldChange}) => {

  const [selected, setSelected] = useState(null);
  const initializedFromMapping = useRef(false);

  function findKeyByValue(fieldMapping, value) {
    if (!fieldMapping || !value) return null;

    // 1. Если это объект (как в твоём примере)
    if (!Array.isArray(fieldMapping) && typeof fieldMapping === 'object') {
      const entry = Object.entries(fieldMapping).find(
        ([, v]) => v === value
      );
      return entry ? entry[0] : null;
    }

    // 2. Если это массив объектов
    if (Array.isArray(fieldMapping)) {
      for (const item of fieldMapping) {
        if (item && typeof item === 'object') {
          const entry = Object.entries(item).find(
            ([, v]) => v === value
          );
          if (entry) return entry[0];
        }
      }
    }

    return null;
  }

  useEffect(() => {
  if (initializedFromMapping.current) return;
  const key = findKeyByValue(fieldMapping, field);
  if (!key) return;
  const option = fieldsToMap?.flatMap(group => group.options)?.find(opt => opt.value === "CSVImportUpdateParticipantsRequest" + key);
  initializedFromMapping.current = true;
  setSelected(option);
}, [field, fieldMapping]);

  const inputRef = useRef(null);

    useEffect(() => {
        if (!savedSettings || !savedSettings.field_mapping) return;
        if (typeChanged !== false) {
            setSelected(null);
            if (inputRef.current) {
            inputRef.current.clearValue();
            }
            return;
        }
        const mapping = savedSettings.field_mapping;
        let foundOption = null;
        Object.keys(mapping).forEach((item) => {
            Object.keys(mapping[item]).forEach((subItem) => {
            if (mapping[item][subItem] === field) {
                foundOption = fieldsToMap
                    ?.flatMap(group => group.options)
                    ?.find(opt => opt.value === item + subItem);
            }
            });
        });
        if (
            foundOption &&
            (!selected || selected.value !== foundOption.value)
        ) {
            setSelected(foundOption);
        }
    }, [savedSettings?.field_mapping, typeChanged, field]);

    const onSelectChange = (selectedOption, actionMeta, input) => {
        if (selectedOption === null && actionMeta?.action !== 'clear') return;
        setSelected(selectedOption);
        input.onChange(selectedOption);
        onFieldChange(field, selectedOption); // ✅ keeps parent mappedFields in sync
    };
  return (
    <div>
      <Row>
        <Col md="3">
          <h5>{field}</h5>
        </Col>
        <Col md="9" lg="7" xl="5">
          <Field name={`fieldsToMap.${field}`}>
            {({input, meta}) => {
                const {onBlur, onChange, ...restInput} = input;
                return (
                <div>
                    <Select
                    options={fieldsToMap}
                    formatOptionLabel={formatOptionLabel}
                    formatGroupLabel={() => null}
                    isClearable={false}
                    className="react-select"
                    classNamePrefix="react-select"
                    placeholder=" - - - "
                    touchUi={false}
                    {...restInput}
                    ref={inputRef}
                    value={selected}
                    onBlur={() => onBlur()}
                    onChange={(selectedOption, actionMeta) => onSelectChange(selectedOption, actionMeta, input)}
                    />
                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                </div>
                );
            }}
            </Field>
        </Col>
      </Row>
    </div>
  )
}

export default FormCsvField;

